import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { toastr } from 'react-redux-toastr';
import { injectIntl } from 'react-intl';
import messages from '@Locales/config/components/login';

import { styles } from './style';
import Header from './header';
import Form from './form';
import LoadingComponent from '@Common/loading';
import selector from '../selector';
import * as actions from './action';
import * as util from '@Util';
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { RECAPTCHA_KEY_V2 } from '@Constants/apiKey';

class SignIn extends Component {
  _isMounted = false;
  state = { recaptchaToken: null };

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.executeRecaptcha = this.executeRecaptcha.bind(this);
    this.handleV2Change = this.handleV2Change.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.executeRecaptcha();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  executeRecaptcha = async () => {
    const { executeRecaptcha } = this.props.googleReCaptchaProps;
      await executeRecaptcha('login')
      .then(token => {
        if (this._isMounted) this.setState({ recaptchaToken: token });
      })
      .catch(() => {
        util.managerExceptionURIMessage({
          customMsg: this.props.intl.formatMessage(messages.recaptchaError)
        });
      })
    };

  async handleV2Change(token) {
    this.props.setRecaptchaV2Selected(true);
    if (!token) return;
    this.setState({ recaptchaToken: token });
  }

  render() {
    const { classes, signInState, intl } = this.props;
    const { recaptchaToken } = this.state;
    const { showV2, recaptchaV2Selected} = signInState;

    const recaptchaHasLoaded =
      !!window.document.getElementsByClassName('grecaptcha-badge')[0];

    return (
      <Grid container className={classes.root}>
        <Grid item xs={12} className={classes.item}>
          <div className={classes.contentForms}>
            <Paper className={classes.control}>
              <Header classes={classes} />
              <Form
                classes={classes}
                validation={signInState.validation}
                isLoading={signInState.fetching || !recaptchaHasLoaded}
                onSubmit={this.onSubmit}
                recaptchaHasLoaded={recaptchaHasLoaded}
                recaptchaToken={recaptchaToken}
                showV2={showV2}
                recaptchaV2Selected={recaptchaV2Selected}
                executeRecaptcha={this.executeRecaptcha}
                recaptchaV2SiteKey={RECAPTCHA_KEY_V2}
                handleV2Change={this.handleV2Change}
              />
              
            </Paper>
          </div>
        </Grid>
      </Grid>
    );
  }

  componentDidUpdate() {
    const { signInState, intl } = this.props;

    if (signInState.message && signInState.message.length) {
      toastr.warning(
        intl.formatMessage(messages.attention),
        signInState.message
      );
      return;
    }
  }

  onSubmit(values) {
    const {
      setSignIn,
      setClearFormError,
      setSignInInvalidEmail,
      setSignInInvalidPassword
    } = this.props;

    if (!values.email) {
      setSignInInvalidEmail();
      return;
    }

    if (!values.password || values.password.length < 6) {
      setSignInInvalidPassword();
      return;
    }

    setClearFormError();
    setSignIn(values);
  }
}

const mapStateToProps = state => ({
  signInState: selector.getSignIn(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setSignIn: actions.signIn,
      setClearFormError: actions.setClearFormError,
      setSignInInvalidEmail: actions.setSignInInvalidEmail,
      setSignInInvalidPassword: actions.setSignInInvalidPassword,
      setRecaptchaV2Selected: actions.setRecaptchaV2Selected
    },
    dispatch
  );

SignIn = withStyles(styles)(SignIn);
SignIn = connect(mapStateToProps, mapDispatchToProps)(SignIn);

export default withGoogleReCaptcha(injectIntl(SignIn));
